import React, { Fragment } from "react";
import styled from "styled-components";
import List from "./UI/List/List";
import ListPayment from "./UI/List/ListPayment";
import Button from "./UI/Button/Button";
import { IC, ListIcon } from "../resources/Assets";
import Label from "./UI/Label/Label";
import Labels from "./UI/Label/Labels";
import ListCardInfo from "./UI/List/ListCardInfo";
import StatusCircleText from "./UI/Status/StatusCircleText";
import AvatarUser from "./UI/Avatar/AvatarUser";
import ListBtn from "./UI/List/List";

const Demo = () => {
  const ListTextData = {
    STATUS: "default",
    // L_ICON: ListIcon.RECEIPT.L_ICON.TIME,
    L_ICON: "",
    // TITLE: "Title",
    TITLE: "비밀번호 변경",
    // SUB_TEXT: {
    //   status: "default",
    //   text: "sub text",
    // },
    R_ICON: ListIcon.RECEIPT.R_ICON.CHEVRON_DEFAULT,
    ACTION: "",
  };

  return (
    <Fragment>
      {/* <Title>컴포넌트 데모</Title> */}

      <Body>
        <Content>
          <ListCardInfo
            status="active"
            bodyInfoHeader="Title"
            bodyInfoBody={[
              {
                left: <StatusCircleText text={"접수가능"} />,
                right: (
                  <TextDiv color="#333" fontWeight="400">
                    월 09:00 ~ 18:00
                  </TextDiv>
                ),
              },

              {
                left: (
                  <TextDiv color="#666" fontWeight="500">
                    96km
                  </TextDiv>
                ),
                right: (
                  <TextDiv color="#888" fontWeight="400">
                    서울특별시 강남구 논현동
                  </TextDiv>
                ),
              },

              {
                left: (
                  <TextDiv color="#888" fontWeight="400">
                    02-0000-0000
                  </TextDiv>
                ),
                right: "",
              },
            ]}
            bodyInfoBottom={
              <Labels
                labels={[
                  {
                    status: "active_green",
                    leftIcon: IC.camera.ICON_CAMERA_GREEN,
                    text: "비대면진료",
                  },
                  {
                    status: "active",
                    text: "label_active",
                  },
                  {
                    status: "default",
                    text: "label_default",
                  },
                ]}
              />
            }
            bodyIcon={[
              {
                icon: ListIcon.RECEIPT.R_ICON.HEART_GRAY,
                action: () => console.log("TEST"),
              },
              {
                icon: ListIcon.RECEIPT.R_ICON.CHEVRON_DEFAULT,
                action: false,
              },
              {
                icon: "",
                action: false,
              },
            ]}
            bottom={[
              {
                text: "방문진료",
                action: () => alert("방문진료"),
              },
              // {
              //   text: "비대면진료",
              //   action: () => alert("비대면진료"),
              // },
            ]}
          />

          <Labels
            labels={[
              {
                status: "active",
                text: "label_active",
              },
              {
                status: "default",
                text: "label_default",
              },
            ]}
          />

          <List data={ListTextData} />

          <ListBtn data={ListTextData} />

          {/* <ListPayment /> */}

          <Button severity="primary" disable="off">
            테스트
          </Button>

          <AvatarUser />
        </Content>
      </Body>
    </Fragment>
  );
};

const Title = styled.div`
  text-align: center;
  font-weight: 700;
  font-size: 16px;
`;

const Body = styled.div`
  margin: 20px;
  display: flex;
  flex-wrap: nowrap;
  gap: 16px;
`;

const Content = styled.div`
  width: 100%;
  display: grid;
  flex: 1 0 0;
  gap: 16px;
`;

const TextDiv = styled.div`
  color: ${(props) => props.color};

  /* Body/3/Regular */
  font-family: Pretendard;
  font-size: 12px;
  font-style: normal;
  font-weight: ${(props) => props.fontWeight};
  line-height: 16px; /* 133.333% */
  letter-spacing: -0.24px;
`;

export default Demo;
